import { styled } from '@mui/material/styles';

const keenSliderSelectors = {
  vertical: '[data-keen-slider-v]',
  moves: '[data-keen-slider-moves]',
} as const;

export const SliderStyled = styled('div')<{ $fade?: boolean }>`
  position: relative;
  display: ${({ $fade }) => ($fade ? 'grid' : 'flex')};
  align-content: flex-start;
  width: 100%;
  overflow: hidden;
  user-select: none;
  touch-action: pan-y;

  &${keenSliderSelectors.vertical} {
    flex-wrap: wrap;
  }

  &${keenSliderSelectors.moves} * {
    pointer-events: none;
  }

  ${({ $fade }) =>
    $fade &&
    `
    & .keen-slider__slide {
      grid-area: 1 / 1;
      opacity: 0;
    }

    & .keen-slider__slide:first-of-type {
      opacity: 1;
    }
  `}
`;

export const SlideStyled = styled('div')`
  position: relative;
  width: 100%;
  min-height: 100%;
  overflow: hidden;

  ${SliderStyled}${keenSliderSelectors.vertical} & {
    width: 100%;
  }
`;
